import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const detachedViewsSliceName = "detachedViewsSlice";

export type DetachedViewsState = Record<string, Date>;

export interface DetachedViewsRootState {
  [detachedViewsSliceName]: DetachedViewsState;
}

const initialState: DetachedViewsState = {};

const detachedViewsSlice = createSlice({
  name: detachedViewsSliceName,
  initialState,
  reducers: {
    setDetachedViewTimestamp: (state: DetachedViewsState, action: PayloadAction<string>) => {
      state[action.payload] = new Date();
    },
  },
});

export const selectDetachedViews = (state: DetachedViewsRootState) => state[detachedViewsSliceName];

export const { setDetachedViewTimestamp } = detachedViewsSlice.actions;
export const detachedViewsReducer = detachedViewsSlice.reducer;
